import type React from 'react';
import { useState } from 'react';

import { type DialogTitleProps } from '@mui/material';

type DialogContent = {
  title: React.ReactNode | React.ReactNode[] | string;
  textContent: React.ReactNode | React.ReactNode[] | string;
  actionButtons?: React.ReactNode | React.ReactNode[];
  titleProps?: DialogTitleProps;
};

const useDialog = () => {
  const [isShowing, setIsShowing] = useState(false);
  const [dialogContent, setDialogContent] = useState<DialogContent | null>(null);

  const toggle = () => {
    setIsShowing(isShowing => !isShowing);
  };

  const handleOpen = () => {
    setIsShowing(true);
  };

  const handleClose = () => {
    setIsShowing(false);
    setDialogContent(null);
  };

  const handleDialogAndStructuredContentOpen = (
    title: React.ReactNode | React.ReactNode[] | string,
    textContent: React.ReactNode | React.ReactNode[] | string,
    actionButtons?: React.ReactNode | React.ReactNode[],
    titleProps?: DialogTitleProps,
  ) => {
    setDialogContent({ title, textContent, actionButtons, titleProps });
    setIsShowing(true);
  };

  return {
    isShowing,
    toggle,
    handleClose,
    handleOpen,
    handleDialogOpen: handleDialogAndStructuredContentOpen,
    dialogContent,
  };
};

export default useDialog;
